var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"caidao-app"},[_c(_vm.$store.state.device,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }